"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyInfuraKey = verifyInfuraKey;
exports.verifyAugustKey = verifyAugustKey;
const constants_1 = require("../constants");
const fetcher_1 = require("../fetcher");
function verifyInfuraKey(key) {
    return __awaiter(this, void 0, void 0, function* () {
        if (key.length !== 32)
            return false;
        const regex = /[a-z0-9]+/i;
        if (!regex.test(key))
            return false;
        return true;
    });
}
function verifyAugustKey(key) {
    return __awaiter(this, void 0, void 0, function* () {
        const verify = yield (0, fetcher_1.fetchAugustWithKey)(key, constants_1.WEBSERVER_ENDPOINTS.auth.verify);
        if (verify.status === 200)
            return true;
        return false;
    });
}
//# sourceMappingURL=verify-keys.js.map